import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useState } from 'react';
import { Page, PageTitleWithButton } from '../../../../components';
import { NewsManagementList } from './news-management-list';

export const NewsManagementPage = () => {
  const [isShowingNewsItemModal, setShowNewsItemModal] = useState(false);
  return (
    <Page title="News Management">
      <PageTitleWithButton
        pageTitleProps={{
          showDivider: false,
          title: 'News Management'
        }}
        button={
          <Button
            onClick={() => {
              setShowNewsItemModal(true);
            }}
            color="primary"
            variant="contained"
            startIcon={<Add />}
          >
            Create News Item
          </Button>
        }
      />
      <NewsManagementList
        showModal={setShowNewsItemModal}
        isShowingModal={isShowingNewsItemModal}
      />
    </Page>
  );
};
